import React from "react";
import { Link } from "@sscs/ui";
import { REGISTER_USER_ROUTE } from "Constants";
import styles from "./loginLayout.module.scss";

const RegisterUserLink = (): React.JSX.Element => {
  return (
    <div className={styles.help}>
      <span>
        New to <strong>Spectra Assure?</strong>{" "}
        <Link to={`/${REGISTER_USER_ROUTE}`} inline={true}>
          Create an account
        </Link>
      </span>
    </div>
  );
};

export default RegisterUserLink;
